import { render, staticRenderFns } from "./TabsAsImages.vue?vue&type=template&id=54cbe389&scoped=true"
import script from "./TabsAsImages.vue?vue&type=script&lang=js"
export * from "./TabsAsImages.vue?vue&type=script&lang=js"
import style0 from "./TabsAsImages.vue?vue&type=style&index=0&id=54cbe389&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cbe389",
  null
  
)

export default component.exports